//from Node
require('js.cookie');
require('bootstrap-datepicker');
require('swiper');
require('slick-carousel');

//from local
require('./radio');
require('../common/password-strength');
require('../common/countdown');
require('../common/modal');
require('./base');
require('./cookie-banner');
require('./swiper-setup');
require('./taketime');
require('./shop');
require('./help-contact');
// Enter the JS for your build here
require('./custom');
